import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Person Multiple Plus Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-person-multiple-plus-outline',
    templateUrl: './icon-person-multiple-plus-outline.component.html',
    styleUrls: ['./icon-person-multiple-plus-outline.component.scss'],
    standalone: false
})
export class IconPersonMultiplePlusOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
